import { render, staticRenderFns } from "./logo-onii-smart-orange-outline-tagline.vue?vue&type=template&id=4c4fbe3b"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports